// Modules
import { useContext, useEffect, useState } from 'react';

import { Alert } from '@/components/Alert/Alert';
import { CookieBanner } from '@/components/CookieBanner/CookieBanner';
import { Dialog } from '@/components/Dialog/Dialog';
import { Footer } from '@/components/Footer/Footer';
import { Header } from '@/components/Header/Header';
import { ProductRight } from '@/components/ProductRight/ProductRight';
// Components
import { Context } from '@/components/Store';
import { log } from '@/lib/log';
import { userHasPur } from '@/lib/util';

type LayoutProps = {
	className: string;
	children: React.ReactNode;
};

const Layout = (props: LayoutProps) => {
	const [state] = useContext(Context);
	const [isPurUser, setIsPurUser] = useState(true);

	useEffect(() => {
		void (async () => {
			setIsPurUser(await userHasPur());
		})().catch((error) => {
			log('Failed to determine PUR status:', error);
		});
	}, []);

	return (
		<>
			{/*CookieBanner needs to stay high up in the DOM to ensure correct keyboard focus order.*/}
			{!isPurUser && <CookieBanner />}
			<div className={['layout', props.className, `theme-${state.productClass}`].join(' ')}>
				<Header />
				<Alert />
				{props.children}
				{!state?.showProductOnRight ? '' : <ProductRight />}
				<Footer />
				<Dialog />
			</div>
		</>
	);
};

export { Layout };
